import React, { useCallback, useState } from 'react';
import { Button } from '@vp/swan';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { CheckoutGateway } from './CheckoutGateway';
import { cartOperations } from '../../../state/cart';

function CheckoutButton({
  trackingCtaValue,
  buttonText,
  disabled,
  size,
  mb,
  skin,
}) {
  const [mountCheckoutGateway, setMountCheckoutGateway] = useState(false);
  const dispatch = useDispatch();
  const reloadCart = useCallback(
    () => dispatch(cartOperations.cartChangedExternally()),
    [dispatch]
  );
  const onClickHandler = () => {
    setMountCheckoutGateway(true);
  };
  const handleResetCheckoutGateway = () => {
    setMountCheckoutGateway(false);
    reloadCart();
  };

  // the "checkout gateway" approach has been favored due to 'useExperiment' firing the impression on call.
  // this allows for that impression to be fired on click instead of on mount of this component
  return (
    <>
      <Button
        component="a"
        skin={skin}
        width="full-width"
        aria-disabled={disabled}
        size={size}
        marginBottom={mb}
        onClick={onClickHandler}
      >
        {buttonText}
      </Button>
      {mountCheckoutGateway ? (
        <CheckoutGateway
          trackingCtaValue={trackingCtaValue}
          resetCheckoutGateway={handleResetCheckoutGateway}
        />
      ) : null}
    </>
  );
}

CheckoutButton.propTypes = {
  trackingCtaValue: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  mb: PropTypes.string,
  // valid swan skin
  skin: PropTypes.string.isRequired,
};

export default CheckoutButton;
